import * as React from 'react';
import { inject, observer } from 'mobx-react';
import styled, { StyledFunction } from 'styled-components';
import CircularProgress from './base/CircularProgress';
import { IStore } from '../../domain/store/IStore';

interface IProps {
  store?: IStore;
}

const StyledDiv: StyledFunction<{ show: boolean } & React.HTMLProps<HTMLInputElement>> = styled.div;
const Wrapper = StyledDiv`
  display: ${props => (props.show ? 'flex' : 'none')};
  justify-content: center;
  align-items: center;
  height: calc(50vh);
  text-align: center;
`;

@inject('store')
@observer
export default class LoadingScreen extends React.Component<IProps, {}> {
  private store: IStore;

  constructor(props: IProps) {
    super(props);
    this.store = props.store!;
  }

  public render() {
    const { uiState } = this.store;
    return (
      <Wrapper show={!uiState.isReady && !uiState.hasError}>
        <CircularProgress size={52} />
      </Wrapper>
    );
  }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/presentation/component/LoadingScreen.tsx